<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content" v-menu-permission="'list'">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
              id="collapseOne"
              class="collapse show"
              aria-labelledby="headingOne"
              data-parent="#accordionFilter"
          >
            <div class="card-body">
              <form>
                <em-filter
                    :entity="modelName"
                    ref="emListFilter"
                    @showEntityModalSelect="
                    $_emCommonModalMixin_showModalSelectorByFilter
                  "
                ></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="sithMesInventoryItemResultTable" class="content">
        <div class="card my-1">
          <div
              id="collapseTwo"
              class="collapse show"
              aria-labelledby="headingTwo"
              data-parent="#accordionResult"
          >
            <div class="card-body">
              <em-table
                  :entity="modelName"
                  ref="emTable"
                  withCustomRowActionsFirstColumn
                  :inlineActionsDisabled="prop_inline !== '1'"
                  @showModalSelectorByNewRow="
                  $_emCommonModalMixin_showModalSelectorByNewRow
                "
                  @showModalSelectorByEditRow="
                  $_emCommonModalMixin_showModalSelectorByEditRow
                "
              >
                <template #left-header>
                  <b-button
                      variant="outline-primary"
                      size="sm"
                      :disabled="actionDisabled('select')"
                      @click="setTagFlag()"
                  >
                    设置免税标记
                  </b-button>
                  <b-button
                      variant="outline-primary"
                      size="sm"
                      :disabled="actionDisabled('select')"
                      @click="setUrgency()"
                  >
                    设置紧急程度
                  </b-button>
                  <b-button
                      variant="outline-primary"
                      size="sm"
                      :disabled="actionDisabled('selectOne')"
                      @click="setPackingBom()"
                  >
                    添加打包物料清单
                  </b-button>
                  <b-button
                      variant="outline-primary"
                      size="sm"
                      @click="receiveItem()"
                  >
                    扫码到货
                  </b-button>
                  <b-button
                      variant="outline-primary"
                      size="sm"
                      :disabled="actionDisabled('select')"
                      @click="batchReceive()"
                  >
                    手动到货
                  </b-button>
                  <b-button
                      variant="outline-primary"
                      size="sm"
                      :disabled="actionDisabled('select')"
                      @click="printLabel()"
                  >
                    打印标签
                  </b-button>
                  <b-button
                      variant="outline-primary"
                      size="sm"
                      :disabled="actionDisabled('selectOne')"
                      @click="createAbnormalArrivalProcess()"
                  >
                    发起异常到货
                  </b-button>
                  <b-button
                      :disabled="actionDisabled('select')"
                      size="sm"
                      variant="outline-primary"
                      @click="openUpdateArea()"
                  >
                    批量设置存放区域
                  </b-button>
                  <em-button
                      :busy="saveAttachmentLoading"
                      :disabled="actionDisabled('selectOne')"
                      class="btn btn-outline-primary btn-sm"
                      custom-label="上传附件"
                      type="uploadFile"
                      @click="openAttachmentModal">
                  </em-button>
                  <em-button :disabled="actionDisabled('select')"
                             :showName="true"
                             custom-label="更新备注"
                             type="search"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             @click="updateRemarkVisible = true"
                  >
                  </em-button>
                  <b-button
                      :disabled="actionDisabled('select')"
                      size="sm"
                      variant="outline-primary"
                      @click="openUpdateInventoryStatus()"
                  >
                    批量更改物流状态
                  </b-button>
                </template>
                <template slot="customRowActions" slot-scope="customRowScope">
                  <b-button-group>
                    <em-button
                        type="task"
                        v-bind:class="'btn btn-outline-primary btn-sm'"
                        @click="
                        $_emWorkflowListMixin_handleApprove(customRowScope.row)
                      "
                    ></em-button>
                  </b-button-group>
                </template>
                  <template #customRowActionsFirstColumn="{ row }">
                      <b-button-group>
                          <em-button type="edit"  custom-icon="fa fa-fw fa-lg fa-search"
                                     custom-label="分批入厂，收货，退货信息"
                                     v-bind:class="'btn btn-outline-primary btn-sm'"
                                     @click="$refs.batchArrivalInfoModal.show(row.id)">
                          </em-button>
                          <em-button
                                  type="gotoChild"
                                  v-bind:class="'btn btn-outline-primary btn-sm'"
                                  @click="gotoChild(row)"
                          ></em-button>
                      </b-button-group>
                  </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector
        ref="emModalEntitySelector"
    ></em-modal-entity-selector>
    <el-dialog
        :title="adjustDialogTitle"
        :center="true"
        width="30%"
        :visible.sync="adjustDialogVisible"
    >
      <div class="col center-name dialog-text">
        <div class="row">
          <div class="col" style="padding-left: 10%">
            <div class="row">
              <el-select
                  v-model="selectedType"
                  :placeholder="adjustPlaceHolder"
              >
                <el-option
                    v-for="item in types"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                />
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="adjustDialogVisible = false">取 消</el-button>
        <el-button
            :loading="submitLoading"
            type="primary"
            @click="submitChange"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="更新打包物料清单"
        :center="true"
        width="80%"
        :visible.sync="updateDialogVisible"
        :close-on-click-modal='false' append-to-body
        :before-close="handleClose"
        @open="initPackingBom"
        @close="clearPackingBom"
    >
      <el-form :model="packingBom" :inline="true" size="mini" ref="bomListForm">
        <div v-for="(item, index) in packingBom.bomList" :key="index">
          <el-row>
            <el-col :span="6">
              <el-form-item
                  label="物料号"
                  :prop="'bomList.' + index + '.materialCode'"
                  :rules="{
                  required: true,
                  message: '物料号不能为空',
                  trigger: 'blur',
                }"
              >
                <el-input v-model="item.materialCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                  label="单位"
                  :prop="'bomList.' + index + '.unit'"
                  :rules="{
                  required: true,
                  message: '单位不能为空',
                  trigger: 'blur',
                }"
              >
                <el-select v-model="item.unit" style="width:100px">
                  <el-option label="PC" value="PC"></el-option>
                  <el-option label="ML" value="ML"></el-option>
                  <el-option label="BOX" value="BOX"></el-option>
                  <el-option label="BT" value="BT"></el-option>
                  <el-option label="M" value="M"></el-option>
                  <el-option label="TMS" value="TMS"></el-option>
                  <el-option label="L" value="L"></el-option>
                  <el-option label="BAG" value="BAG"></el-option>
                  <el-option label="M2" value="M2"></el-option>
                  <el-option label="KG" value="KG"></el-option>
                  <el-option label="MM" value="MM"></el-option>
                  <el-option label="SET" value="SET"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                  label="数量"
                  :prop="'bomList.' + index + '.quantity'"
                  :rules="{
                  required: true,
                  message: '数量不能为空',
                  trigger: 'blur',
                }"
              >
                <el-input v-model="item.quantity"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-button
                    v-if="index + 1 == packingBom.bomList.length"
                    @click="addItem"
                    type="primary"
                >
                  增加
                </el-button>
                <el-button
                    v-if="packingBom.bomList.length != 1"
                    @click="deleteItem(item)"
                    type="danger"
                >
                  删除
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer">
        <el-button @click="handleClose">关闭</el-button>
        <el-button @click="resetForm('bomListForm')">重置</el-button>
        <el-button
            :loading="submitLoading"
            type="primary"
            @click="updateBomList('bomListForm')"
        >
          提交修改
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
        title="货物列表"
        :visible.sync="receiveDialogVisible"
        :close-on-click-modal='false' append-to-body
        @close="clearItemList"
    >
      <!-- <div class="row">
        <el-select v-model="selectedArea" placeholder="请选择存放区域">
          <el-option
            v-for="area in areas"
            :key="area.id"
            :label="area.name"
            :value="area.id"
          />
        </el-select>
        <el-select v-model="selectedSize" placeholder="请选择物料大小类别">
          <el-option
            v-for="size in sizes"
            :key="size.id"
            :label="size.name"
            :value="size.id"
          />
        </el-select>
      </div> -->
      <el-table
          :data="itemList"
          @selection-change="handleSelectionChange"
          ref="multipleTable"
          height="150"
          empty-text="请点击打开扫码框扫码"
      >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column label="指派收货人" fixed>
              <template slot-scope="scope">
                  <el-select v-model="scope.row.assignedConsigneeId" placeholder="指派收货人" filterable :required="true" :disabled="setUserIdSame">
                      <el-option
                              v-for="user in userOptions"
                              :key="user.value"
                              :label="user.label"
                              :value="user.value"
                      />
                  </el-select>
                  <el-checkbox :value='true' label="批量设置" v-model="setUserIdSame"
                               @change="changeAll(scope.row.assignedConsigneeId)"></el-checkbox>
              </template>
          </el-table-column>
        <el-table-column prop="materielName" label="名称"></el-table-column>
        <el-table-column prop="materielUnit" label="单位"></el-table-column>
        <el-table-column prop="urgency" label="紧急程度">
          <template slot-scope="scope">
            {{ getUrgencyName(scope.row.urgency) }}
          </template>
        </el-table-column>
        <el-table-column prop="taxFlag" label="免税标记">
          <template slot-scope="scope">
            {{ getTaxFlagName(scope.row.taxFlag) }}
          </template>
        </el-table-column>
        <el-table-column label="采购数量" prop="purchaseQuantity"></el-table-column>
        <el-table-column label="已到数量" prop="arrivedQuantity"></el-table-column>
        <el-table-column label="本次到货">
          <template slot-scope="scope">
            <el-input clearable v-model="scope.row.currentQuantity" size="small"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="存放区域">
          <template slot-scope="scope">
            <el-select v-model="scope.row.locId" placeholder="请选择">
              <el-option
                  v-for="area in areas"
                  :key="area.id"
                  :label="area.name"
                  :value="area.id"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="大小">
          <template slot-scope="scope">
            <el-select v-model="scope.row.size" placeholder="请选择">
              <el-option
                  v-for="size in sizes"
                  :key="size.id"
                  :label="size.name"
                  :value="size.id"
              />
            </el-select>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
          title="扫一扫"
          :center="true"
          :visible.sync="openScanner"
          append-to-body
          @close="closeScannerDialog"
          :close-on-click-modal="false"
      >
        <qr-code-scanner
            ref="scanner"
            @getCodeData="getCodeData"
        ></qr-code-scanner>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button @click="receiveDialogVisible = false">取 消</el-button>
        <el-button @click="openScannerDialog()">打开扫码框</el-button>
        <el-button @click="toggleSelection()">取消选择</el-button>
        <el-button
            type="primary"
            @click="batchConfirmArrival('scan')"
            :disabled="selectedItems.length == 0"
        >
          确认到货
        </el-button>
        <!-- <el-button
          type="primary"
          @click="createAbnormalArrivalProcess()"
          :disabled="selectedItems.length == 0"
        >
          发起异常到货
        </el-button> -->
      </div>
    </el-dialog>
    <!-- 批量手动确认到货Dialog -->
    <el-dialog title="批量到货" :visible.sync="batchReceiveDialogVisible" :close-on-click-modal='false' append-to-body
               @close="clearItemList">
      <el-table :data="showItems" ref="itemTable" style="width:100%" max-height="285px">
          <el-table-column label="指派收货人" fixed>
              <template slot-scope="scope">
                  <el-select v-model="scope.row.assignedConsigneeId" placeholder="指派收货人"  filterable :disabled="setUserIdSame" :required="true">
                      <el-option
                              v-for="user in userOptions"
                              :key="user.value"
                              :label="user.label"
                              :value="user.value"
                      />
                  </el-select>
                  <el-checkbox  :value='true' label="批量设置" v-model="setUserIdSame" @change="changeAll(scope.row.assignedConsigneeId)"></el-checkbox>
              </template>
          </el-table-column>
        <el-table-column label="PO" fixed prop="purchaseNumber"></el-table-column>
        <el-table-column label="ITEM" fixed prop="itemCode"></el-table-column>
        <el-table-column label="名称" fixed prop="materielName"></el-table-column>
        <el-table-column label="单位" prop="materielUnit"></el-table-column>
        <el-table-column label="采购数量" prop="purchaseQuantity"></el-table-column>
        <el-table-column label="已到数量" prop="arrivedQuantity"></el-table-column>
        <el-table-column label="本次到货">
          <template slot-scope="scope">
            <el-input clearable v-model="scope.row.currentQuantity" size="small"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="存放区域">
          <template slot-scope="scope">
            <el-select v-model="scope.row.locId" placeholder="请选择">
              <el-option
                  v-for="area in areas"
                  :key="area.id"
                  :label="area.name"
                  :value="area.id"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="大小">
          <template slot-scope="scope">
            <el-select v-model="scope.row.size" placeholder="请选择">
              <el-option
                  v-for="size in sizes"
                  :key="size.id"
                  :label="size.name"
                  :value="size.id"
              />
            </el-select>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchReceiveDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchConfirmArrival('manual')">确认到货</el-button>
      </div>
    </el-dialog>

    <!-- 批量设置存放区域 -->
    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="updateAreaVisible" title="批量设置存放区域" width="30%"
               @close='clearUpdateArea'>
      <el-form ref="updateAreaForm" :model="updateAreaForm" :rules="updateAreaRule" label-width="auto">
        <el-form-item label="存放区域" prop="locId">
          <el-select v-model="updateAreaForm.locId" placeholder="请选择">
            <el-option
                v-for="area in areas"
                :key="area.id"
                :label="area.name"
                :value="area.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateAreaVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchUpdateArea()">确认</el-button>
      </div>
    </el-dialog>
    <ReBModal ref="uploadAttachment"
              header="上传附件"
              @ok="submitAttachmentChange">
      <multi-attachment :attachment-ids="attachmentIds"
                        :query-api="attachmentQueryApi"
                        class="w-100"
                        @idsChanged="changeAttachmentIds"
                        @loading="attachmentLoading"></multi-attachment>
    </ReBModal>
    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="updateRemarkVisible" title="更新备注" width="30%"
               @close='clearUpdateRemark'>
      <el-form ref="updateRemarkForm" :model="updateForm" :rules="updateRemarkRule" label-width="auto">
        <el-form-item label="备注" prop="remark">
          <el-input v-model="updateForm.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateRemarkVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateRemark()">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="updateInventoryStatusVisible" title="批量更改物流状态"
               width="30%" z-index="1000" @close='clearUpdateInventoryStatus'>
      <el-form ref="updateInventoryStatusForm" :model="updateInventoryStatusForm" :rules="updateInventoryStatusRules"
               label-width="auto">
        <b-form-input
            id="inventoryStatusSelector"
            v-model="updateInventoryStatusForm.inventoryStatusCode"
            class="form-control col-2 inventory-status"
            placeholder="请选择物流状态"
            plaintext
            type="text"
            @click="$refs.inventoryStatusSelector.showModal()"
        ></b-form-input>
        <b-table ref="selectableTable" :fields="this.detailFields" :items="this.inventoryStatusList"
                 :select-mode='selectMode'
                 max-height="285px"
                 selectable
                 style="width:100%"
                 @row-selected="onRowSelected">
        </b-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateInventoryStatusVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchUpdateInventoryStatus()">确认</el-button>
      </div>
      <em-modal-normal-input-entity-selector ref="inventoryStatusSelector" entity="sithMesInventoryStatus"
                                             @entityModalSelectSelected="updateInventoryStatus">
      </em-modal-normal-input-entity-selector>
    </el-dialog>
    <inventory-batch-arrival-info-modal ref="batchArrivalInfoModal" />
  </div>
</template>
<script>
// Author Lin
// Date 2021-04-21 11:22:06

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emCommonApiMixin from "@/mixin/em/common/api";
import qrCodeScanner from "@/components/QRCode/QRCodeScannerForInventory";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import MultiAttachment from "@/components/echarts-part/stuff/MultiAttachment";
import EmModalNormalInputEntitySelector from "@/components/em/EmModal/NormalInputEntitySelector";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import InventoryBatchArrivalInfoModal from "@/components/SithMes/inventory/InventoryBatchArrivalInfoModal.vue";

export default {
  components: {InventoryBatchArrivalInfoModal, qrCodeScanner, ReBModal, MultiAttachment, EmModalNormalInputEntitySelector},
  name: "sithMesInventoryItemListView",
  mixins: [
    emCommonListMixin,
    emCommonGotoMixin,
    emCommonApiMixin,
    qrCodeScanner,
    emCommonUtilMixin
  ],
  props: {
    //是否启用行编辑
    prop_inline: {
      type: String,
      default: "0",
    },
  },
  data() {
    return {
      types: [],
      selectedType: "",
      adjustDialogTitle: "",
      adjustDialogVisible: false,
      adjustPlaceHolder: "",
      submitLoading: false,
      updateDialogVisible: false,
      receiveDialogVisible: false,
      openScanner: false,
      //打包物料清单
      packingBom: {
        bomList: [],
      },
      userOptions: [],
      itemList: [],
      //选中需要确认到货的物料
      selectedItems: [],
      //物料存放区域
      areas: [],
      //物料规格
      sizes: [
        {id: 0, name: "大件物料"},
        {id: 1, name: "中等物料"},
        {id: 2, name: "小件物料"},
      ],
      //选中的物料存放区域
      selectedArea: "",
      //选中的物料规格
      selectedSize: "",
      // 批量到货dialog
      batchReceiveDialogVisible: false,
      showItems: [],
      updateAreaVisible: false,
      updateAreaForm: {
        locId: ''
      },
        setUserIdSame:false,
      updateAreaRule: {locId: [{required: true, message: '请选择存放区域'}]},
      attachmentIds: '',
      saveAttachmentLoading: false,
      updateRemarkVisible: false,
      updateForm: {
        remark: ''
      },
      updateRemarkRule: {remark: [{required: true, message: '请输入备注'}]},

      updateInventoryStatusVisible: false,
      updateInventoryStatusForm: {
        inventoryStatusCode: ''
      },
      updateInventoryStatusRules: {inventoryStatusCode: [{required: true, message: '请选择物流状态！'}]},
    };
  },
  computed: {
    modelName() {
      return this.$_emRouterHelperMixin_entityName;
    },
    entityBaseUrl() {
      return `${this.$_emApiMixin_entityBaseApi(this.modelName)}/`
    },
    checkedItems() {
      //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
      return this.$store.state[this.modelName]["checkedItems"];
      // return this.$refs.emTable.checkedItems
    },
    selectIds() {
      //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
      return this.$store.state[this.modelName]["checkedItems"].join(",");
    },
    choosenItems() {
      let self = this;
      let choosenArry = this.$store.state[this.modelName]["rows"].filter(function (x) {
        return self.checkedItems.indexOf(x.id) > -1;
      });
      return choosenArry;
    },
    attachmentQueryApi() {
      return `${process.env.VUE_APP_SITHMES_INVENTORY_URL}/${this.modelName}/getAttachmentList`;
    },
  },
  methods: {
      changeAll(userId) {
          for (let i = 0; i < this.showItems.length; i++) {
              this.showItems[i].assignedConsigneeId = userId;
          }
      },
    //根据按钮上设置的选中类型和实际列表中选中的项目，判断按钮是否可点
    actionDisabled(type) {
      // 删除按钮在一条记录都没选的时候禁用
      if (type === "select") {
        // return this.$refs.emTable.checkedItems && this.$refs.emTable.checkedItems.length === 0;
        return this.checkedItems && this.checkedItems.length === 0;
      }
      // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
      else if (type === "selectOne") {
        // return this.$refs.emTable.checkedItems && this.$refs.emTable.checkedItems.length !== 1;
        return this.checkedItems && this.checkedItems.length !== 1;
      }
    },
    //点击设置免税标记，将共用dialog的属性设为免税标记相关内容
    setTagFlag() {
      this.types = [
        {id: 0, name: "免税"},
        {id: 1, name: "不免税"},
      ];
      (this.adjustDialogTitle = "免税标记设置"),
          (this.adjustPlaceHolder = "点击选择是否免税"),
          (this.adjustDialogVisible = true);
    },
    //点击设置紧急程度，将共用dialog的属性设为紧急程度相关内容
    setUrgency() {
      this.types = [
        {id: 0, name: "紧急"},
        {id: 1, name: "一般"},
      ];
      (this.adjustDialogTitle = "紧急程度设置"),
          (this.adjustPlaceHolder = "点击选择紧急程度"),
          (this.adjustDialogVisible = true);
    },
    //打开设置打包物料的dialog
    setPackingBom() {
      this.updateDialogVisible = true;
    },
    //打开收货dialog
    receiveItem() {
      this.receiveDialogVisible = true;
    },
    //设置免税标记和紧急程度共用的提交方法
    submitChange() {
      let self = this;
      let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/`;
      if (this.adjustDialogTitle === "紧急程度设置") {
        _url += `urgency-adjust?ids=${this.selectIds}&type=${this.selectedType}`;
      }
      if (this.adjustDialogTitle === "免税标记设置") {
        _url += `tax-flag-adjust?ids=${this.selectIds}&type=${this.selectedType}`;
      }

      this.$_emApiMixin_post(_url, {})
          .then((request) => {
            if (request.status === 200) {
              self.dialogVisible = false;
              self.$message({
                message: "修改成功！",
                type: "success",
              });
              self.$refs.emListFilter.doQuery();
            } else {
              self.$message({
                message: "修改失败！",
                type: "error",
              });
            }
          })
          .finally(() => {
            this.adjustDialogVisible = false;
          });
    },
    //从PO Item页面跳转到对应的打包物料清单页面
    gotoChild(row) {
      this.$_emGotoMixin_gotoHolderList(
          "sithMesInventoryPackingBom",
          {itemIdFilter: row.id},
          {itemId: row.id},
          true,
          {}
      );
    },
    //添加打包物料清单时新增一行
    addItem() {
      this.packingBom.bomList.push({
        materialCode: "",
        unit: "",
        quantity: "",
      });
    },
    //添加打包物料清单时删除一行
    deleteItem(item) {
      let index = this.packingBom.bomList.indexOf(item);
      if (index !== -1) {
        this.packingBom.bomList.splice(index, 1);
      }
    },
    //打开添加打包物料清单时根据当前选中的POITEM的ID查找其对应的打包物料作为基础数据
    initPackingBom() {
      this.$_emApiMixin_findByFilter("sithMesInventoryPackingBom", {
        itemIdFilter: this.selectIds,
      }).then((data) => {
        if (data.length === 0) {
          this.packingBom.bomList.push({materialCode: "", description: "", unit: "", quantity: "", status: ""});
        } else {
          this.packingBom.bomList = data.map((m) => {
            return {
              materialCode: m.materialCode,
              description: m.description,
              unit: m.unit,
              quantity: m.quantity,
              status: m.status
            };
          });
        }
      });
    },
    //关闭添加打包物料dialog时，清空form对应的data
    clearPackingBom() {
      this.packingBom.bomList = [];
    },
    //清空已输入的打包物料
    resetForm(formName) {
      console.log(this.$refs[formName]);
      this.$refs[formName].resetFields();
    },
    //关闭打包物料dialog时让用户确认一下
    handleClose(done) {
      let self = this;
      self
          .$confirm("确认放弃本次修改？")
          .then((_) => {
            self.updateDialogVisible = false;
            done();
          })
          .catch((_) => {
          });
    },
    //调用后端接口更新打包物料
    updateBomList(formName) {
      let self = this;
      let _url = `${this.$_emApiMixin_entityBaseApi(
          "sithMesInventoryPackingBom"
      )}/updateBomList`;
      self.$refs[formName].validate((valid) => {
        if (valid) {
          self.packingBom.bomList.forEach((bom) => {
            bom.itemId = parseInt(self.selectIds);
          });
          let update = {};
          update.bomList = self.packingBom.bomList;
          self
              .$_emApiMixin_post(_url, update)
              .then((request) => {
                if (request.status === 200) {
                  self.$message({
                    message: "修改成功！",
                    type: "success",
                  });
                } else {
                  self.$message({
                    message: "修改失败！",
                    type: "error",
                  });
                }
              })
              .finally(() => {
                this.updateDialogVisible = false;
              });
        } else {
          console.log("error submit");
          return false;
        }
      });
    },
    //记录选中的收货项
    handleSelectionChange(val) {
      console.log(val);
      this.selectedItems = val;
    },
    //清除选择的收货项
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    closeScannerDialog() {
      this.$refs.scanner.closeCamera();
      this.$refs.scanner.resetOutputData();
      this.openScanner = false;
    },
    /**清空扫码收货Dialog中关联的数据项 */
    clearItemList() {
      this.itemList = [];
      this.selectedItems = [];
      this.showItems = [];
      this.selectedArea = "";
      this.selectedSize = "";
    },
    getCodeData(data) {
      console.log("get qr code data:" + data);
      this.openScanner = false;
      let self = this;
      //检验二维码的数据格式
      try {
        var obj = JSON.parse(data);
        var poNumber = obj.PO;
        var item = obj.PoItem;
        console.log(poNumber);
        console.log(item);
      } catch (error) {
        self.$message({
          message: "无效的二维码",
          type: "error",
        });
        return;
      }

      let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/`;
      _url += `checkObtainedItem?poNumber=${poNumber}&item=${item}`;
      this.$_emApiMixin_get(_url, {})
          .then((value) => {
            var arr = Object.keys(value);
            if (arr.length != 0) {
              console.log("value======" + JSON.stringify(value));
              //已有扫码记录中不包含该物料，则添加到扫码物料结果中，提示扫码成功
              if (
                  self.itemList.findIndex((item) => {
                    return item.id === value.id;
                  }) == -1
              ) {
                if (typeof (value.arrivedQuantity) == 'undefined') {
                  value.arrivedQuantity = 0;
                }
                let obj = Object.assign(value, {currentQuantity: value.purchaseQuantity - value.arrivedQuantity});
                self.itemList.push(obj);
                self.$message({
                  message: "扫码成功",
                  type: "success",
                });
              } else {
                //已经扫描过的物料提示重复扫描
                self.$message({
                  duration: 5000,
                  message: "重复扫码",
                  type: "success",
                });
              }
            } else {
              self.$message({
                message: "无对应物料或物料已到货",
                type: "error",
              });
            }
          })
          .finally(() => {
            this.openScanner = false;
          });
    },
    printLabel(row) {

      let url = `${this.entityBaseUrl}getInventoryPrintList?ids=${this.$store.state[this.modelName]["checkedItems"].join(",")}`
      this.$_emApiMixin_post(url, {})
          .then(response => {
            this.$router.push({
              name: "sithMesInventoryItemPrint",
              query: response.data,
            });
          })
    },
    getAreas() {
      this.$_emApiMixin_findByFilter("sithMesInventoryAreaLoc", {}).then(
          (data) => {
            this.areas = data.map((m) => {
              return {id: m.id, name: m.areaName};
            });
          }
      );
    },
    confirmArrival(type = 'scan') {
      let self = this;
      let _url = `${this.$_emApiMixin_entityBaseApi(
          "sithMesInventoryItem"
      )}/confirmArrival`;
      let requestBody = {};
      let ids = '';
      if (type === 'scan') {
        ids = self.selectedItems
            .map((obj) => {
              return obj.id;
            })
            .join(",");
      }
      if (type === 'manual') {
        ids = this.selectIds;
      }
      requestBody.idStr = ids;
      requestBody.selectedAreaId = self.selectedArea;
      requestBody.selectedSize = self.selectedSize;
      self
          .$_emApiMixin_post(_url, requestBody)
          .then((request) => {
            if (request.status === 200) {
              self.$message({
                message: "确认到货成功！",
                type: "success",
              });
              self.$refs.emListFilter.doQuery();
            } else {
              self.$message({
                message: "确认到货失败！",
                type: "error",
              });
            }
          })
          .finally(() => {
            this.receiveDialogVisible = false;
            this.batchReceiveDialogVisible = false;
          });
    },
    createAbnormalArrivalProcess() {
      // let poItemId = this.selectedItems[0].id;
      let poItemId = this.selectIds;
      console.log("异常的物料：" + poItemId);
      this.$router.push(
          "/sithMes/inventory/sithMesInventoryAbnormalArrivalProcessEdit"
      );
      this.$store.commit(
          "sithMesInventoryAbnormalArrivalProcess/setNewEntity",
          {}
      );
      this.$store.commit(
          "sithMesInventoryAbnormalArrivalProcess/setCrudState",
          "edit"
      );
      this.$store.commit(
          "sithMesInventoryAbnormalArrivalProcess/setEntityAttribute",
          {key: "poItemId", newValue: poItemId}
      );
    },
    // 打开批量到货dialog
    batchReceive() {
      let arr = JSON.parse(JSON.stringify(this.choosenItems));
      this.showItems = arr.map(row => {
        //如果已到货数量为空，设置初始值0；本次默认到货数为采购数减去已到货数
        if (typeof (row.arrivedQuantity) == "undefined") {
          row.arrivedQuantity = 0;
        }
        return Object.assign(row, {currentQuantity: row.purchaseQuantity - row.arrivedQuantity})
      });
      console.log("selected===" + JSON.stringify(this.showItems));

      this.batchReceiveDialogVisible = true;
    },
    // 新的批量到货方法,扫码和手动到货通过type区分
    batchConfirmArrival(type) {
      let self = this;
      let ids;
      let requestBody;
      if (type === 'scan') {
        ids = self.selectedItems.map(x => {
          return x.id
        }).join(",");
        requestBody = self.selectedItems;
      } else {
        ids = self.selectIds;
        requestBody = self.showItems;
      }
        for (let i = 0; i < requestBody.length; i++) {
            if (!requestBody[i].assignedConsigneeId) {
                self.$message({
                    message: "必须给每个物料指派收货员！",
                    type: "error",
                });
                return;
            }
        }
      let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/batchConfirmArrival?ids=${ids}`;
      self
          .$_emApiMixin_post(url, requestBody)
          .then((request) => {
            if (request.status === 200) {
              self.$message({
                message: "确认到货成功！",
                type: "success",
              });
              self.$refs.emListFilter.doQuery();
            } else {
              self.$message({
                message: "确认到货失败！",
                type: "error",
              });
            }
          })
          .finally(() => {
            self.showItems = [];
            self.selectedItems = [];
            self.receiveDialogVisible = false;
            self.batchReceiveDialogVisible = false;
          });
    },
    // 获取紧急程度整数标识对应的描述
    getUrgencyName(type) {
      if (type) {
        switch (type) {
          case 0:
            return '紧急'
          case 1:
            return '一般'
        }
      }
    },
    // 获取免税标记整数标识对应的描述
    getTaxFlagName(type) {
      if (type) {
        switch (type) {
          case 0:
            return '免税'
          case 1:
            return '不免税'
        }
      }
    },
    openScannerDialog() {
      this.openScanner = true;
      setTimeout(() => {
        this.$refs.scanner.openCamera('');
      }, 500);
    },
    openUpdateArea() {
      this.updateAreaVisible = true;
    },
    clearUpdateArea() {
      this.updateAreaForm.locId = ''
    },
    batchUpdateArea() {
      let self = this;
      self.$refs["updateAreaForm"].validate(valid => {
        if (valid) {
          let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/batchUpdateArea?ids=${this.selectIds}&locId=${self.updateAreaForm.locId}`
          self.$_emApiMixin_post(url, {})
              .then(response => {
                if (response.status === 200) {
                  self.$message({
                    message: "更新成功",
                    type: "success",
                  });

                  self.$refs.emListFilter.doQuery();
                } else {
                  self.$message({
                    message: "更新失败",
                    type: "error",
                  });
                }
              })
              .finally(() => this.updateAreaVisible = false)
        } else {
          self.$message({
            message: "数据不完整",
            type: "error",
          });
          return;
        }
      })
    },
    openAttachmentModal() {
      this.attachmentIds = this.$store.state[this.modelName].rows.filter(row => this.$store.state[this.modelName].checkedItems.indexOf(row.id) !== -1)[0].attachment;
      this.$refs.uploadAttachment.showModal();
    },
    submitAttachmentChange() {
      let checkedItem = this.checkedItems[0];
      this.saveAttachmentLoading = true;
      let api = process.env.VUE_APP_SITHMES_INVENTORY_URL + "/" + this.modelName + "/upload/attachment";
      this.$_emApiMixin_put(api, {
        id: checkedItem,
        attachment: this.attachmentIds === undefined ? "" : this.attachmentIds
      }).then(() => {
        this.$message.success("保存成功");
        this.$refs.emListFilter.doQuery();
      }).finally(() => this.saveAttachmentLoading = false);
    },
    attachmentLoading(val) {
      this.$refs.uploadAttachment.changeLoading(val);
    },
    changeAttachmentIds(ids) {
      this.attachmentIds = ids;
    },
    clearUpdateRemark() {
      this.updateForm.remark = ''
    },
    updateRemark() {
      let self = this;
      self.$refs["updateRemarkForm"].validate(valid => {
        if (valid) {
          let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/updateRemark?ids=${this.selectIds}&remark=${self.updateForm.remark}`
          self.$_emApiMixin_post(url, {})
              .then(response => {
                if (response.status === 200) {
                  self.$message({
                    message: "更新成功",
                    type: "success",
                  });

                  self.$refs.emListFilter.doQuery();
                } else {
                  self.$message({
                    message: "更新失败",
                    type: "error",
                  });
                }
              })
              .finally(() => this.updateRemarkVisible = false)
        } else {
          self.$message({
            message: "数据不完整",
            type: "error",
          });
          return;
        }
      })
    },

    updateInventoryStatus(selectRow) {
      console.log(selectRow)
      this.updateInventoryStatusForm.inventoryStatusCode = selectRow.code;
    },

    openUpdateInventoryStatus() {
      this.updateInventoryStatusVisible = true;
    },
    clearUpdateInventoryStatus() {
      this.updateInventoryStatusForm.inventoryStatusCode = ''
    },
    batchUpdateInventoryStatus() {
      let self = this;
      this.$refs["updateInventoryStatusForm"].validate(valid => {
        if (valid) {
          let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/batchUpdateInventoryStatus?ids=${this.selectIds}&inventoryStatusCode=${self.updateInventoryStatusForm.inventoryStatusCode}`
          self.$_emApiMixin_post(url, {})
              .then(response => {
                if (response.status === 200) {
                  self.$message({
                    message: "批量更改物流状态成功",
                    type: "success",
                  });

                  self.$refs.emListFilter.doQuery();
                } else {
                  self.$message({
                    message: "批量更改物流状态失败",
                    type: "error",
                  });
                }
              })
              .finally(() => this.updateInventoryStatusVisible = false)
        } else {
          self.$message({
            message: "数据不完整",
            type: "error",
          });
          return;
        }
      })
    },
  },
    watch: {
        batchReceiveDialogVisible(val) {
            console.log(val)
          if (val && this.userOptions.length === 0) {
              let url = `${this.$_emApiMixin_entityBaseApi("emAclUser")}/findByFilter`
              this.$_emApiMixin_post(url, {
                      deptIdFilter:228326,
                      statusFilter:"1",
              }).then(response => {
                  for (let row of response.data.list) {
                      this.userOptions.push({
                          value: row['id'],
                          label: row['loginName'] + '-' + row['name'],
                      });
                  }}
              )
          }
      }
    },
  mounted() {
    this.getAreas();
  },
};
</script>

<style lang="scss" scoped>
.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;

.el-dialog {
  margin: 0 auto !important;
  height: 90%;
  overflow: hidden;

.el-dialog__body {
  position: absolute;
  left: 0;
  top: 54px;
  bottom: 0;
  right: 0;
  padding: 0;
  z-index: 1;
  overflow: hidden;
  overflow-y: auto;
}

}
}
</style>
